export function isEmailAddress(email: string) {
    let emailString = email.trim();
    if (emailString.indexOf('<') > -1 && emailString.indexOf('<') + 1 < emailString.length - 1) {
        emailString = emailString.substring(emailString.indexOf('<') + 1, emailString.length - 1);
    }
    const addressPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/;
    return addressPattern.test(emailString);
}
